module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate2_m.a5213e916ea1807840d8c6dfe18f9f6c.png";